export function getCurrentYear() {
  const currentYear = new Date().getFullYear();
  return currentYear;
}
